import {pipe} from 'fp-ts/lib/function'
import {useCallback, useState} from 'react'
import {
  Datagrid,
  EmailField,
  List,
  TextField,
  EditButton,
  Edit,
  SimpleForm,
  TextInput,
  SaveButton,
  Toolbar,
  Button,
  useEditContext,
  ToolbarProps,
  ArrayField,
  Create,
  DateInput,
  useRecordContext,
  BooleanInput,
  Labeled,
  ReferenceInput,
  SelectInput,
  useGetList,
  CheckboxGroupInput,
} from 'react-admin'
import {TE} from 'shared/dist/fp-ts-imp'
import PosIntInput from './comps/PosIntInput'
import {addUserToAccessTravel, AdminUser} from './dataProvider'
import {
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Switch,
} from '@mui/material'
import {vROrgId} from 'shared/dist/types/Organization'
import {organizations} from './App'
import {VertOnlineCategoryC} from 'shared/dist/types/VertOnlineOffer'

const userFilters = [
  <TextInput label="Phone Number" source="phoneNbr" alwaysOn />,
  <TextInput label="Email" source="email" alwaysOn />,
  <ReferenceInput
    source="organizationId"
    reference="organizations"
    link="show"
    alwaysOn>
    <SelectInput optionText="name" />
  </ReferenceInput>,
  <TextInput label="Name" source="name" />,
]
export const UserList = () => (
  <List filters={userFilters} filterDefaultValues={{organizationId: vROrgId}}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="organizationName" label="Organization" />
      <TextField source="name" label="Name" />
      <EmailField source="email" />
      <TextField source="phoneNbr" label="Phone" />
      <EditButton />
    </Datagrid>
  </List>
)
const UserEditToolbar: React.FC<ToolbarProps> = props => {
  const {record: user} = useEditContext<AdminUser>()
  const [isCAD, setIsCAD] = useState(false)

  const onAddAccessTravelUser = useCallback(() => {
    if (!user) return
    pipe(
      addUserToAccessTravel(user.id, isCAD),
      TE.map(({cvt}) =>
        alert(`User added to Access Travel program with CVT (${cvt})`),
      ),
    )()
  }, [user, isCAD])

  return (
    <Toolbar
      style={{
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 10,
      }}
      {...props}
      sx={{columnGap: 10}}>
      <FormGroup style={{flexDirection: 'row', gap: 15, alignItems: 'center'}}>
        <Button
          label="Add Access Travel User"
          onClick={onAddAccessTravelUser}
        />

        <FormControlLabel
          control={
            <Switch value={isCAD} onChange={() => setIsCAD(cv => !cv)} />
          }
          label="Use Canadian Currency?"
        />
        <a
          href={`https://www.verticaldiscounts.com/webviews/access-travel-v2/${user?.jwt}`}
          target="_blank">
          Test Access Travel Site as this user
        </a>
      </FormGroup>
      <SaveButton />
    </Toolbar>
  )
}

const CommonFields = () => (
  <>
    <ReferenceInput
      label="Organization"
      source="organizationId"
      reference={organizations}
      required
    />
    <TextInput source="name" />
    <TextInput source="email" />
    <PosIntInput fieldName="phoneNbr" label="Phone" />
    <TextInput source="fundraiserName" label="Fundraiser Name" />
    <TextInput
      source="participantImageUrl"
      label="Fundraiser Logo URL"
      fullWidth
    />
    <TextInput source="fundraiserId" label="Fundraiser Id" />
    <DateInput source="subscriptionEndDate" label="Subscription End Date" />
    <BooleanInput source="promotionAccount" label="Promotional Account" />
  </>
)

// what a shame it is to be working with this framework and React and JS and just everything
const CountryOrNotSet = () => {
  const record = useRecordContext()
  return <span> Country: {record?.['country'] ?? 'not set'} </span>
}

export const UserEdit = () => {
  return (
    <Edit>
      <SimpleForm toolbar={<UserEditToolbar />}>
        <CommonFields />
        {/* Country: {`${userDisplay}`} */}
        <CountryOrNotSet />
        <br />
        Push notification tokens:
        <ArrayField source="pushTokens" label="Push Notification Tokens">
          <Datagrid bulkActionButtons={false}>
            <TextField source="token" />
            <TextField source="platform" />
          </Datagrid>
        </ArrayField>
      </SimpleForm>
    </Edit>
  )
}

export const UserCreate = () => {
  return (
    <Create>
      <SimpleForm>
        <CommonFields />
        <TextInput source="address1" defaultValue="" hidden />
        <TextInput source="address2" defaultValue="" hidden />
        <TextInput source="city" defaultValue="" hidden />
        <TextInput source="state" defaultValue="" hidden />
        <TextInput source="zip" defaultValue="" hidden />
        <TextInput source="stripeToken" defaultValue="" hidden />
        <TextInput source="accessCVT" defaultValue="" hidden />
        <TextInput source="subscriptionStarted" defaultValue={true} hidden />
      </SimpleForm>
    </Create>
  )
}
